import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../../router/all_routes";
import { logoutService } from "../../../../services/authService";
import { useTranslation } from "react-i18next";
import { useAbility } from "@casl/react";
import { AbilityContext } from "../../../../config/abilityContext";

const MobileUserDropdown = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const ability = useAbility(AbilityContext);
  const { t } = useTranslation();

  const handleLogout = async () => {
    // delete fcm token
    // await deleteTokenFCM(); // ✅ Wait for clean removal
    await logoutService(navigate);
  };

  return (
    <div>
      <Link
        to="#"
        className="nav-link dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <i className="fa fa-ellipsis-v" />
      </Link>
      <div className="dropdown-menu dropdown-menu-end">
        <Link className="dropdown-item d-inline-flex align-items-center p-2" to={routes.profile}>
          <i className="ti ti-user me-2" /> {t('profile')}
        </Link>
        {ability.can("update", "SettingsInstance") && (
          <Link className="dropdown-item d-inline-flex align-items-center p-2" to={routes.instanceSettings}>
            <i className="ti ti-settings me-2" /> {t('settings')}
          </Link>
        )}
        <Link className="dropdown-item d-inline-flex align-items-center p-2" to={routes.login} onClick={handleLogout}>
          <i className="ti ti-logout me-2" /> {t('logout')}
        </Link>
      </div>
    </div>
  );
};

export default MobileUserDropdown;